import React, { Component } from "react";
import "./modal.scss"
export default class Modal extends Component {
    handleClick(event){
        ( typeof window !== "undefined"    &&
            event.target.className === "modal" ) &&
        document.body.classList.toggle("modal-open")
    }
    render () {
        const {handleCounter} = this.props;
        return (
            <span className="modal" role={"dialog"} onClick={this.handleClick}>
                <button onClick={handleCounter(-1)} id={"left"}/>
                {this.props.children}
                <button onClick={handleCounter(1)} id={"right"}/>
            </span>
        )
    }
}